import { getWorkLocations } from '../../services/workService';
import Map from '../../common/mapping/Map';

export interface IWorkMapParams {
  workId: number | undefined;
}

const WorkMap = (params: IWorkMapParams) => (
  <Map
    Id={params.workId}
    getLocations={async (
      abortController: AbortController,
      rentId: number,
      pageSize: number,
      pageNo: number
    ) => await getWorkLocations(abortController, rentId, pageSize, pageNo)}
  />
);

export default WorkMap;
